import React, { SyntheticEvent } from 'react'
import ReactDatePicker from "react-datepicker";

export interface DatePickerInterface {
    dateFormat: string,
    selected: Date,
    maxDate?: Date,
    customInput?: any,
    placeholderText?: string
    startOpen?: boolean,
    classes?: any,
    id?: string,
    onChange: (date: Date | null, event: SyntheticEvent<any> | undefined) => void
}
const DatePicker = (props: DatePickerInterface) => {
    return (
        <>
            <span className={props.classes}>
                <img src="/assets/svg/calender.svg" alt='calender_icon' onClick={() => {
                    //@ts-ignore
                    document.getElementById(props.id) && document.getElementById(props.id).click()
                    }}/>
            </span>
            <ReactDatePicker
                {...props}
            />
        </>);
}

export default DatePicker